export const TEST_ID = 'chemicalDetailIngredients';
